"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    width: "25",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M24.5,25h-24C0.2,25,0,24.8,0,24.5S0.2,24,0.5,24h24c0.3,0,0.5,0.2,0.5,0.5S24.8,25,24.5,25z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M20.3,25c-0.2,0-0.4-0.1-0.5-0.4L13.1,1h-1.3L5.2,24.6c-0.1,0.3-0.4,0.4-0.6,0.3c-0.3-0.1-0.4-0.4-0.3-0.6 l6.8-24C11,0.1,11.2,0,11.5,0h2.1c0.2,0,0.4,0.1,0.5,0.4l6.8,24c0.1,0.3-0.1,0.5-0.3,0.6C20.4,25,20.4,25,20.3,25z"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: "#EC6833",
    points: "10,5.7 15,5.7 16.2,9.9 8.8,9.9     "
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: "#EC6833",
    points: "6.2,19.3 18.8,19.3 17.7,15.1 7.3,15.1     "
  }));
};

exports["default"] = _default;